import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [];

  return (
    <nav className="fixed w-full z-50 glass py-4 transition-all duration-300">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
        
        {/* Logo Section */}
        <Link
          to="/simulations"
          className="flex items-center gap-2 cursor-pointer group"
        >
          <div className="w-8 h-8 rounded bg-linear-to-tr from-primary to-secondary flex items-center justify-center font-bold text-white shadow-lg transform group-hover:scale-110 transition-transform">
            A
          </div>
          <span className="text-xl font-bold tracking-tight text-main">
            Acczite <span className="text-primary font-light text-base">Simulations</span>
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            if (link.external) {
              return (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-medium text-secondary-text hover:text-primary transition-colors py-1"
                >
                  {link.name}
                </a>
              );
            }
            return (
              <Link
                key={link.name}
                to={link.href}
                className={`text-sm font-medium transition-all duration-300 relative py-1 ${isActive ? 'text-primary' : 'text-secondary-text hover:text-primary'}`}
              >
                {link.name}
                {isActive && (
                  <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-primary rounded-full shadow-[0_0_8px_rgba(16,185,129,0.5)]" />
                )}
              </Link>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="hidden lg:flex items-center gap-6">
          <a
            href="https://acczite.in"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2.5 rounded-full bg-primary text-white text-sm font-semibold hover:bg-emerald-400 transition-colors shadow-lg shadow-primary/10 flex items-center gap-2 group"
          >
            Visit Acczite
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="lg:hidden text-main p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full bg-white border-b border-glass py-6 px-8 flex flex-col gap-4 shadow-xl">
          {navLinks.map((link) => (
            link.external ? (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileMenuOpen(false)}
                className="text-lg font-semibold text-secondary-text hover:text-primary transition-colors"
              >
                {link.name}
              </a>
            ) : (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-lg font-semibold ${location.pathname === link.href ? 'text-primary' : 'text-secondary-text'}`}
              >
                {link.name}
              </Link>
            )
          ))}
          <hr className="border-glass my-2" />
          <a
            href="https://acczite.in"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-3 rounded-xl bg-primary text-white text-center font-bold shadow-lg shadow-primary/20 flex items-center justify-center gap-2"
          >
            Visit Acczite
            <ArrowRight size={16} />
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
